import {ChartView} from "./ChartView";

export default ChartView

export { ChartView } from "./ChartView";
